/* =========================================================
   SHÔBI — Favoris (wishlist) — logique partagée
   Stockage 100% côté navigateur (localStorage), aucune app requise.
   Chargé une seule fois, sur toutes les pages, via le header.
   ========================================================= */
(function () {
  var STORAGE_KEY = 'sb_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* navigation privée / storage plein : on continue sans persister */
    }
    updateUI();
    document.dispatchEvent(new CustomEvent('sb:wishlist:change', { detail: { list: list } }));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var i = list.indexOf(handle);
    if (i === -1) {
      list.push(handle);
    } else {
      list.splice(i, 1);
    }
    saveWishlist(list);
    return isInWishlist(handle);
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function (h) { return h !== handle; });
    saveWishlist(list);
  }

  function updateUI() {
    var count = getWishlist().length;

    document.querySelectorAll('[data-sb-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });

    document.querySelectorAll('[data-sb-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-sb-wishlist-toggle');
      var active = isInWishlist(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /* Un seul écouteur de clic global : fonctionne pour n'importe quel
     bouton [data-sb-wishlist-toggle], même ajouté dynamiquement plus
     tard (grille filtrée, produits chargés en Ajax, etc.) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sb-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(btn.getAttribute('data-sb-wishlist-toggle'));
  });

  window.ShobiWishlist = {
    get: getWishlist,
    toggle: toggleWishlist,
    remove: removeFromWishlist,
    isIn: isInWishlist,
    refresh: updateUI
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateUI);
  } else {
    updateUI();
  }
})();
